<ng-container *transloco="let t; prefix: 'teamsBanner'">
  <ng-container *rmaLet="showContactForm$ as showContactForm">
    @if (cardFooter) {
      <div class="footer-container">
        <img alt="" class="footer-img-container" [src]="teamImage | staticImageUrl" />
        <div class="text-container">
          <span class="footer-heading">{{ t('title', { name: name }) }}</span>
          <span class="footer-description">{{ showContactForm ? t('description.checkout') : t('description.checkout-organic') }}</span>
          @if (showContactForm) {
            <a class="link-button" [href]="teamUrl" mat-button color="primary">
              {{ t('button') }} <rma-icon glyph="call_made" matButtonIcon />
            </a>
          } @else {
            <a class="link-button" mat-button color="accent" routerLink="/billing/checkout/team">
              @if (trialPeriodDays$ | async; as trialPeriodDays) {
                {{ t('button-organic-trial', { trialPeriodDays: trialPeriodDays }) }}
              } @else {
                {{ t('button-organic-upgrade') }}
              }
            </a>
          }
        </div>
      </div>
    } @else {
      @if (!isDismissed) {
        <div class="banner-container">
          <div class="content-container">
            <img alt="" class="img-container" [src]="teamImage | staticImageUrl" />
            <div class="banner-text">
              <span class="heading">{{ t('title', { name: name }) }}</span>
              <span class="description">{{ showContactForm ? t('description.home') : t('description.home-organic') }}</span>
            </div>
          </div>
          @if (showContactForm) {
            <a class="contact-button" [href]="teamUrl" mat-flat-button>{{ t('button') }}</a>
          } @else {
            <a [queryParams]="teamsQueryParams$ | async" mat-flat-button color="accent" routerLink="/billing/subscription-features">
              @if (trialPeriodDays$ | async; as trialPeriodDays) {
                {{ t('button-organic-trial', { trialPeriodDays: trialPeriodDays }) }}
              } @else {
                {{ t('button-organic-upgrade') }}
              }
            </a>
          }
          <button type="button" class="close" (click)="onClose()" mat-icon-button>
            <rma-icon glyph="close" matButtonIcon />
          </button>
        </div>
      }
    }
  </ng-container>
</ng-container>
